import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import {
  LOAD_USER,
  LOAD_USER_SUCCESS,
  LOG_USER_OUT,
  LoadUserFail,
  LoadUserSuccess,
  UPDATE_USER_INFO,
} from './user.actions';
import { UserApiService } from '../../api-services/services/user-api.service';
import { PostHogManagerService } from '../../analytic-process/services/posthog-manager.service';
import { PostHogConsentService } from '../../analytic-process/services/posthog-consent.service';

@Injectable()
export class UserEffects {
  private readonly _actions$ = inject(Actions);
  private readonly _userApi = inject(UserApiService);
  private readonly _postHogManager = inject(PostHogManagerService);

  private _postHogService = inject(PostHogConsentService);

  loadUser$: Observable<LoadUserSuccess | LoadUserFail> = createEffect(() =>
    this._actions$.pipe(
      ofType(LOAD_USER),
      switchMap(() => {
        return this._userApi.fetchCurrentUser().pipe(
          map((user) => new LoadUserSuccess(user)),
          catchError((error) => of(new LoadUserFail(error))),
        );
      }),
    ),
  );

  identifyUser$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(LOAD_USER_SUCCESS, UPDATE_USER_INFO),
        tap((action: LoadUserSuccess) => this._postHogManager.identifyUser(action.payload)),
      ),
    { dispatch: false },
  );

  resetPostHogIdentity$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(LOG_USER_OUT),
        tap(() => {
          this._postHogManager.reset();
          this._postHogService.syncConsent();
        }),
      ),
    { dispatch: false },
  );
}
